import React, { forwardRef } from 'react';

export const InputField = forwardRef(
  (
    {
      placeholder,
      label,
      error,
      extraClasses = '',
      height = '36',
      paddingLeft = 'md',
      paddingRight = 'md',
      type = 'text',
      disabled = false,
      ...rest
    },
    ref,
  ) => {
    const text = error || label || '';
    return (
      <div className="w--full d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--sm  ${
              error ? 'text--danger' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <input
          type={type}
          {...rest}
          ref={ref}
          placeholder={placeholder}
          className={`form--control w--full h-min--${height}  radius--sm p-l--${paddingLeft} p-r--${paddingRight} ${extraClasses} ${error ? 'border-full--danger' : 'border-full--black-200'}`}
          disabled={disabled}
        />
      </div>
    );
  },
);
